import { createFileRoute } from "@tanstack/react-router";
import KnotApp from "@/components/KnotApp";

export const Route = createFileRoute("/")({
  component: KnotApp,
});
